import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Provider as ProviderStore } from "mobx-react";
import { ThemeProvider as ThemeProviderStyled } from "styled-components";
import reportWebVitals from "./reportWebVitals";
import DefaultStore from "./store/Store";
import { DefaultTheme, GlobalStyled } from "./theme";
import RoutesMenu from "./routes/Routes";
import "./index.css";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import {ToastProvider} from "./components/toast";
import { getSearchWithoutAuth0CallbackParams } from "./utils/auth0Cache";

// ✅ Suppress harmless passive event listener warning from Scrollbar component
// This warning comes from @ann/web-components Scrollbar and doesn't affect functionality
const originalError = console.error;
console.error = (...args) => {
    if (args[0]?.includes?.('Unable to preventDefault inside passive event listener')) return;
    originalError(...args);
};

const segmentScript = document.createElement("script");
segmentScript.type = "text/javascript";
segmentScript.async = true;
segmentScript.src =
  "https://cdn.segment.com/analytics.js/v1/wQtkyaBqtMHrVz3FReAN7iK9lYHbTBk7/analytics.min.js";
document.head.appendChild(segmentScript);

const root = ReactDOM.createRoot(document.getElementById("root"));
const defaultTheme = createTheme();

const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
  cacheLocation: "localstorage",
  useRefreshTokens: true,
  useRefreshTokensFallback: false,
  authorizationParams: {
    redirect_uri: window.location.origin,
    scope: "openid profile email offline_access",
    ...(process.env.REACT_APP_AUTH0_AUDIENCE && {
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    }),
  },
  onRedirectCallback: (appState) => {
    const returnTo = appState?.returnTo || window.location.pathname || "/";
    const { search: cleanSearch } = getSearchWithoutAuth0CallbackParams(
      window.location.search
    );
    window.history.replaceState(
      {},
      document.title,
      `${returnTo}${cleanSearch}${window.location.hash}`
    );
  },
};

root.render(
  <Auth0Provider {...auth0Config}>
    <ThemeProvider theme={defaultTheme}>
      <ThemeProviderStyled theme={DefaultTheme}>
        <GlobalStyled />
        <ProviderStore myStore={DefaultStore}>
          <ToastProvider config={{ position: "top-right", defaultDuration: 5000, max: 5 }}>
            <RouterProvider router={RoutesMenu} />
          </ToastProvider>
        </ProviderStore>
      </ThemeProviderStyled>
    </ThemeProvider>
  </Auth0Provider>
);

reportWebVitals();
